const COOKIE_LANG = 'lang'
const DEFAULT_HOST = '/'

export default {
    COOKIE_LANG: COOKIE_LANG,
    DEFAULT_HOST: DEFAULT_HOST
}


// WEBPACK FOOTER //
// ./src/consts.js